<template>
  <div :class="$style.component">
    <slot>
      <div
        v-if="$listeners.close"
        :class="$style.closeButton"
        @click="$emit('close')"
      >
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g>
            <circle cx="30" cy="26" r="19.5" stroke="black"/>
          </g>
          <path d="M23.3334 19.7972L37.0848 32.6206" stroke="black" stroke-width="1.5"/>
          <path d="M23.7972 33.0847L36.6206 19.3333" stroke="black" stroke-width="1.5"/>
        </svg>
      </div>
      <h2>{{title}}</h2>
      <p>{{description}}</p>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
  },
}
</script>

<style module lang="scss">
.component {
  background-color: variables.$white;
  height: auto;
  min-height: 350px;
  position: relative;
  border: 1px solid #000;
  border-radius: variables.$border-radius;
  padding: 70px 50px;
  text-align: center;

  h2 {
    margin-bottom: variables.$spacing-16;
  }
}

.closeButton {
  cursor: pointer;
  background-color: transparent;
  position: absolute;
  left: 6px;
  top: 6px;
  width: 40px;
}
</style>
